// Neu (SPEC 03 §6.2, §7.1) — die Person und ihr Verfahren-Kontext.
//
// `["ich"]` ist DIE Abfrage von GET /api/me (staleTime 5 min). Wurzel in App.tsx macht den
// einen Aufruf; jeder andere Leser hängt sich an denselben Zwischenspeicher. Keine zweite
// Wahrheit über die Person im Speicher (useAuthStore weiß nur, OB jemand angemeldet ist).
import { useQuery } from "@tanstack/react-query";
import { holeIch } from "../api/client";
import type { Ich, IchVerfahren, Recht } from "../api/typen";
import { hatRecht } from "../lib/rechte";
import { useStore } from "../store/useStore";

export function useIch(aktiv = true) {
  return useQuery<Ich>({ queryKey: ["ich"], queryFn: holeIch, staleTime: 5 * 60_000, enabled: aktiv, placeholderData: undefined });
}

/** Das Verfahren aus `ich.verfahren` samt Rechten — `null`, wenn es fehlt (→ „Unbekannt“). */
export function useIchVerfahren(V: string | null | undefined): IchVerfahren | null {
  const { data: ich } = useIch();
  if (!ich || !V) return null;
  return ich.verfahren.find((v) => v.code === V) ?? null;
}

/** hatRecht als Haken: `const darf = useRecht(V); darf("pruefen")`. */
export function useRecht(V: string | null | undefined): (r: Recht) => boolean {
  const { data: ich } = useIch();
  return (r: Recht) => hatRecht(ich, V, r);
}

/** Das aktuelle Verfahren der Shell (Pfad, Objekt oder zuletzt benutzt). */
export function useAktuellesVerfahren(): string | null {
  return useStore((s) => s.verfahren);
}
